import { extend, $ } from './HelperFunctions'

export class MainNavigation {
  constructor (selectors) {
    this.selectors = extend({
      hamburgerButton: '[data-js-hamburger]',
      mainNavigation: '[data-js-main-navigation]',
      languageNavigation: '[data-js-language-navigation]'
    }, selectors)
  }

  init () {
    this.initHamburger()
  }

  initHamburger () {
    const that = this
    const hamburgerButton = $(that.selectors.hamburgerButton)
    const languageNavigation = $(that.selectors.languageNavigation)
    if (hamburgerButton) {
      hamburgerButton.addEventListener('click', function () {
        const expanded = this.getAttribute('aria-expanded')

        if (expanded === 'false') {
          this.setAttribute('aria-expanded', 'true')
          languageNavigation?.classList.add('is--visible')
        } else {
          this.setAttribute('aria-expanded', 'false')
          languageNavigation?.classList.remove('is--visible')
        }
      }, false)

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && hamburgerButton.getAttribute('aria-expanded') === 'true') {
          hamburgerButton.setAttribute('aria-expanded', 'false')
          languageNavigation?.classList.remove('is--visible')
        }
      })

      if (hamburgerButton.getAttribute('aria-expanded') === 'true') {
        document.addEventListener('click', function (event) {
          if (event.target !== $(that.selectors.mainNavigation) &&
            event.target.parentNode.closest(that.selectors.mainNavigation) !== $(that.selectors.mainNavigation) &&
            event.target !== hamburgerButton) {
            hamburgerButton.setAttribute('aria-expanded', 'false')
            languageNavigation?.classList.remove('is--visible')
          }
        })
      }
    }
  }
}

export default MainNavigation
